import { Box } from '@mui/material';
import HeaderNotifications from './Notifications';

function HeaderButtons() {
  return (
    <Box sx={{ display: "none" }}>
      <HeaderNotifications />
    </Box>
  );
}

export default HeaderButtons;
